import styled from "styled-components";
import { Button } from "../../../../../base/buttons/button/index.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import addRoomThemes from "./themes/index.js";
export const AddRoomButton = styled(Button).withConfig({
    displayName: "styled__AddRoomButton",
    componentId: "sc-de18a299-0"
})`
	color: ${({ theme  })=>theme.colors.primary.base};
	${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
	${FlexMixin({
    align: 'center'
})}
	text-transform: initial;

	&.has-error {
		opacity: 0.5;
	}

	${({ theme  })=>addRoomThemes[theme.id]?.AddRoomButton?.()};
`;

//# sourceMappingURL=styled.js.map